import { render, staticRenderFns } from "./examinations.vue?vue&type=template&id=27b3f55c&scoped=true"
import script from "./examinations.vue?vue&type=script&setup=true&lang=ts"
export * from "./examinations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./examinations.vue?vue&type=style&index=0&id=27b3f55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3f55c",
  null
  
)

export default component.exports